// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"fL-z","carouselContainer":"gL-z"};